module.exports = __webpack_public_path__ + "static/media/protects.a8755267.mp3";